// extracted by mini-css-extract-plugin
module.exports = {"csr_h5_A":"A_csr_h5_A__jw0WA"};